<template>
  <a-spin :spinning="loading" tip="در حال ثبت اطلاعات">
    <a-list :locale="{emptyText:'رکوردی وجود ندارد.'}" bordered item-layout="horizontal">
      <a-list-item class="grid grid-cols-3" v-for="(item,index) in estimate" :key="index">
        <div>
          <a-tooltip placement="bottomRight">
            <template slot="title">
              <span>حذف</span>
            </template>
            <a-popconfirm :disabled="!$getAccess('personnel.function.delete')"
                          placement="right"
                          title="آیا می خواهید حذف کنید؟"
                          ok-text="بله"
                          cancel-text="خیر"
                          @confirm="removeEstimate(item)">
              <a-button type="danger" class="mr-3">حذف</a-button>
            </a-popconfirm>
          </a-tooltip>
        </div>

        <div>نمره : {{ item.score }}</div>
        <div> برنامه توسعه دوره : <span>{{ item.note }} </span></div>
      </a-list-item>
    </a-list>
    <br/>
    <a-button class="ml-2" :disabled="!$getAccess('personnel.function.create')"
              @click="showAddPerformance=true">افزودن ردیف
    </a-button>
    
    <a-modal @ok="savefromPerformance" okText="ایجاد" forceRender cancelText="بستن" v-model="showAddPerformance"
             title="افزودن ارزیابی عملکرد">
      <a-form :form="fromPerformance">
        <a-form-item label="نمره">
          <a-input-number autocomplete="off" :min="0" :max="20"
                          v-decorator="['score',{ rules:[{ required: true, message: 'وارد کردن الزامی است'  }] }]"/>
        </a-form-item>
        <a-form-item label="برنامه توسعه دوره">
          <input class="ant-input" autocomplete="off"
                 v-decorator="['note',{ rules:[{ required: false, message: 'وارد کردن الزامی است'  }] }]"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-spin>
</template>

<script>
import axios from "@/axios";

export default {
  name: "estimate",
  props: {
    estimate: Array
  },
  data() {
    return {
      loading: false,
      showAddPerformance: false,
      fromPerformance: this.$form.createForm(this, {name: 'fromPerformance'}),
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  methods: {
    async removeEstimate(item) {
      if (item.id) {
        try {
          await axios.post('/personnel/remove-estimate', {id: item.id});
          this.$emit('update')
        } catch (e) {

        console.log(e);
        }
      } else {
        const index = this.estimate.indexOf(item);
        this.estimate.splice(index, 1);
      }
    },
    savefromPerformance(e) {
      e.preventDefault();
      this.fromPerformance.validateFields(async (err, values) => {
        if (!err) {
          let estimate = this.estimate
          estimate.push(values);
          this.showAddPerformance = false;
          this.$message.success('اطلاعات با موفقیت ثبت شد');
          this.fromPerformance.resetFields();
          await this.saveData(estimate);
        } else {
          this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
        }
      });
    },
    async saveData(estimate) {
      if (estimate) {
        try {
          this.loading = true
          let values = {
            estimate: estimate,
            id: this.id
          }
          values.documents = this.documents;
          if (!this.$getAccess('personnel.train')) {
            values.estimate = this.estimate
          }
          await axios.post('/personnel/estimate/update', values);
          this.$emit('update')
          this.$ntSet()
        } catch (e) {
          this.$ntSetError()

          console.log(e)
        } finally {
          this.loading = false
          this.showAddPerformance = false
        }
      } else {
        this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
      }
    },
  }
}
</script>

<style scoped>

</style>